import { gql } from 'apollo-angular';
import { Page } from '../../entities/page/page';
import { TimeEntryCategory } from '../../entities/timeEntryCategory/timeEntryCategory';


export const TIME_ENTRY_CATEGORIES_QUERY = gql`
query timeEntryCategoriesQuery(
  $pageNumber: Int,
  $pageSize: Int,
  $sortProperty: String,
  $sortDirection: String,
  $enabled: Boolean,
)
{
  timeEntryCategories: getTimeEntryCategoriesPaged(
    filter: {
      enabled: $enabled
    },
    sortRequest: { sortProperties: [$sortProperty], sortDirection: $sortDirection },
    pagination: { number: $pageNumber, size: $pageSize,  sortProperty: $sortProperty, sortDirection: $sortDirection}
    ) {
      totalPages
      totalElements
      number
      size
      content{
          id
          name
          externalId
          color
          enabled
      }
  }
}
`;

export interface TimeEntryCategoriesQueryResponse {
  timeEntryCategories: Page<TimeEntryCategory>;
  loading: boolean;
}
